import type {
	CustomItem,
	DropSpinsAlgorithmInformationType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropSpinsAlgorithmInformation = (
	item: Item | CustomItem
): item is DropSpinsAlgorithmInformationType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Spins_Algorithm_Information'
	);
};
